import { Box, Grid, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import CampoTextoIA from "../components/CampoTextoIA";

const StepEstructura = ({ formik, camposIA, desmarcarCampoIA }) => (
  <Box>
    <Typography variant="h6" gutterBottom>
      Estructura de la Propuesta
    </Typography>
    <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
      Describe la solución que Taxtic propone. ¿Cómo se abordará el problema del
      cliente? ¿Cuál es el enfoque general del trabajo?
    </Typography>

    <Grid container spacing={2}>
      <Grid item xs={12} id="seccion-alcance">
        <CampoTextoIA
          formik={formik}
          name="alcance"
          label="Alcance y estructura de la solución"
          multiline
          minRows={8}
          contextIA="Sección de alcance/estructura en una propuesta comercial tributaria. Describe la solución propuesta."
          camposIA={camposIA}
          desmarcarCampoIA={desmarcarCampoIA}
        />
      </Grid>
    </Grid>
  </Box>
);

StepEstructura.propTypes = {
  formik: PropTypes.object.isRequired,
  camposIA: PropTypes.instanceOf(Set),
  desmarcarCampoIA: PropTypes.func,
};

StepEstructura.defaultProps = {
  camposIA: new Set(),
  desmarcarCampoIA: undefined,
};

export default StepEstructura;
